export default {

    type:{
        type:String,
        default:'default'
    }

}
